import React, { useEffect, useState } from "react";
import ReactModal from 'react-modal'
import request from "../../helpers/request";
import endpoints from "../../helpers/endpoints";

export default function LinkedReferenceTable ({summaryData, translations, prefix}) {
    const [data, setData] = useState([])
    const [customPostcode, setCustomPostcode] = useState()
    const [postcodeModal, setPostcodeModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const getData = (postcode) => {
        if (!summaryData.Core_SPID) return
        setLoading(true)
        setData([])
        request(true).get(endpoints[`${prefix}_LINKED_REFERENCES`], {
            doesCancel: true,
            params: {
                postcode: postcode || customPostcode || summaryData.CF_Postcode || summaryData.CMOS_Postcode
            }
        }).then(r => {
            setData(r.data)
            setLoading(false)
        }).catch(e => {
            setLoading(false)
            console.log(e)
        })
    }

    useEffect(() => {
        getData()
    }, [summaryData])

    useEffect(() => {
        setCustomPostcode()
        if (!summaryData.Core_SPID) {
            setData([])
        }
    }, [summaryData.Core_SPID])

    return (
        <div style={{overflowY: 'auto', maxHeight: '70vh', width: "100%"}}>
            <table className="table borders squish scale-text">
                <thead style={{ position: 'sticky', top: '0px' }}>
                    <tr>
                        <th>UPRN</th>
                        <th>VOA BA Reference</th>
                        <th>UPRN Address</th>
                        <th>
                            <div style={{ display: 'flex', alignItems: 'center', position: 'relative', justifyContent: 'center' }}>
                                VOA Address
                                <div style={{ display: 'flex', gap: 10, position: 'absolute', width: '100%', justifyContent: 'flex-end' }}>
                                    {customPostcode && (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <span className='fas fa-trash-undo' onClick={() => { setCustomPostcode(); getData(summaryData.CF_Postcode || summaryData.CMOS_Postcode) }} title="Restore original postcode search"></span>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                                    </div>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-spin"></i>
                        : data.length > 0 ?
                            data.map(row => {
                                const brAddress = row.br?.Full_Property_Identifier
                                const brPostcode = row.br?.Postcode
                                return (
                                    <tr>
                                        <td>{row.ABPlus_UPRN}</td>
                                        <td>{row.br?.BA_Reference_Number}</td>
                                        <td>{row.abp?.SINGLE_LINE_ADDRESS}</td>
                                        <td>{brAddress ? `${brAddress}${brPostcode ? `, ${brPostcode}` : ''}` : ''}</td>
                                    </tr>
                                )
                            })
                        :
                            <tr>
                                <td/><td/><td/><td/>
                            </tr>
                    }
                </tbody>
            </table>
            <ReactModal
                isOpen={postcodeModal}
                onRequestClose={() => setPostcodeModal(false)}
                className="card bulk-allocate"
                contentLabel="Bulk Allocate COT Alert Data"
                style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <h3>Postcode Search</h3>
                        <input value={customPostcode ? customPostcode : data?.[0]?.Premises_Address_Postcode} onChange={_ => setCustomPostcode(_.target.value.toUpperCase())} 
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    getData(customPostcode)
                                    setPostcodeModal(false);
                                }
                            }}
                            style={{ border: '1px solid gray', width: '100%', borderRadius: 3 }} />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <button className={`button compact smaller-text ${customPostcode?.length >= 3 ? 'background-primary colour-white' : ''}`} disabled={customPostcode?.length < 3} onClick={() => { getData(customPostcode); setPostcodeModal(false); }}>Search</button>
                        </div>
                    </div>
            </ReactModal>
        </div>
    )
}